
    <div
      *ngIf="fetching$ | async"
      fieldmagicGridRow
    >
      <div fieldmagicGridColumn="12">
        <div
          class="d-flex justify-content-center w-100"
        >
          <fieldmagic-icon [spin]="true"></fieldmagic-icon>
        </div>
      </div>
    </div>

    <ng-container>
      <div fieldmagicGridRow>
        <div fieldmagicGridColumn="12">
          <div class="d-flex d-flex-gap flex-column flex-column">
            <div class="d-flex justify-content-between align-items-center w-100">
              <fieldmagic-text
                purpose="title"
                content="Prompts"
                class="w-50"
              >
              </fieldmagic-text>

              <div class="d-flex d-flex-gap justify-content-end w-50">
                <fieldmagic-relate-input
                  class="w-100"
                  [(ngModel)]="variant"
                  [standalone]="true"
                  placeholder="Select a variant"
                  moduleName="asset_type_variants"
                  [filter]="{
                    asset_type_id: id$ | async
                  }"
                  (ngModelChange)="onVariantChange()"
                >
                </fieldmagic-relate-input>

                <fieldmagic-dropdown-input
                  class="w-100"
                  [(ngModel)]="checklist"
                  [options]="checklists$ | async"
                  [standalone]="true"
                  (ngModelChange)="onChecklistChanged()"
                  placeholder="Select a checklist.."
                  [clearable]="false"
                >
                </fieldmagic-dropdown-input>
              </div>
            </div>

            <table class="table table-bordered">
              <thead>
                <tr>
                  <td width="20%">
                    <fieldmagic-text
                      purpose="table-header"
                      content="Prompt"
                    >
                    </fieldmagic-text>
                  </td>

                  <td width="10%">
                    <fieldmagic-text
                      purpose="table-header"
                      content="Type"
                    >
                    </fieldmagic-text>
                  </td>

                  <td width="20%">
                    <fieldmagic-text
                      purpose="table-header"
                      content="Value"
                    >
                    </fieldmagic-text>
                  </td>

                  <td width="5%">
                    <fieldmagic-icon
                      position="center"
                      icon="asterisk"
                      class="text-danger"
                      tooltip="{{ 'tooltip_required' | translate }}"
                    >
                    </fieldmagic-icon>
                  </td>

                  <td width="5%">
                    <fieldmagic-icon
                      position="center"
                      icon="desktop"
                      tooltip="{{ 'tooltip_report_visibility' | translate }}"
                    ></fieldmagic-icon>
                  </td>

                  <td width="5%">
                    <fieldmagic-icon
                      position="center"
                      icon="file-image"
                      tooltip="{{ 'add_image_to_prompt' | translate }}"
                    ></fieldmagic-icon>
                  </td>

                  <td width="5%">
                    <fieldmagic-icon
                      position="center"
                      icon="file-image"
                      tooltip="Require atleast 1 image to the prompt"
                      [withRequiredMarker]="true"
                    ></fieldmagic-icon>
                  </td>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngIf="prompts$ | async as prompts">
                  <tr
                    *ngIf="prompts | blank"
                    class="text-center"
                  >
                    <td colspan="7">{{ error$ | async }}</td>
                  </tr>

                  <ng-container *ngFor="let prompt of prompts">
                    <ng-container *ngIf="prompt.type != 'group'">
                      <ng-container
                        [ngTemplateOutlet]="promptTmp"
                        [ngTemplateOutletContext]="{
                          prompt: prompt
                        }"
                      ></ng-container>
                    </ng-container>

                    <ng-container *ngIf="prompt.type == 'group'">
                      <tr>
                        <td colspan="7">{{ computeGroupName(prompt) }}</td>
                      </tr>
                      <ng-container  *ngFor="let subprompt of prompt.prompts">
                        <ng-container
                          *ngIf="subprompt.type != 'group'"
                          [ngTemplateOutlet]="promptTmp"
                          [ngTemplateOutletContext]="{
                            prompt: subprompt,
                            as_sub: true
                          }"
                        ></ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                  <ng-template
                    #promptTmp
                    let-prompt="prompt"
                    let-as_sub="as_sub"
                  >
                    <tr
                      [class.inspection-group-subprompt-row]="as_sub"
                    >
                      <td>
                        <span class="inspection-prompt-name">{{ prompt.prompt }}</span>
                      </td>
                      <td>
                        <span class="inspection-prompt-type">
                          {{ prompt.type | translate }}
                        </span>
                      </td>
                      <td>
                        <span *ngIf="prompt.type != 'instructions'" class="inspection-prompt-value">
                          {{ computePromptValue(prompt) | placeholdWithString }}
                        </span>

                        <div *ngIf="prompt.type == 'instructions'">
                          <fieldmagic-textarea-input
                            [ngModel]="prompt | data_get: 'value.instructions_text'"
                            [wyswyg]="true"
                            [disabled]="true"
                          >
                          </fieldmagic-textarea-input>
                        </div>
                      </td>
                      <td class="text-center">
                        <span class="inspection-prompt-is-required">{{ (prompt.is_required ? 'Yes' : 'No') | translate }}</span>
                      </td>
                      <td class="text-center">
                        <span class="inspection-prompt-is-report-visible">{{ (prompt.is_visible_in_reports ? 'Yes' : 'No') | translate }}</span>
                      </td>
                      <td class="text-center">
                        <span class="inspection-prompt-with-image">{{ (prompt.is_image_enabled ? 'Yes' : 'No') | translate }}</span>
                      </td>
                      <td class="text-center">
                        <span class="inspection-prompt-image-required">{{ (prompt.is_image_required ? 'Yes' : 'No') | translate }}</span>
                      </td>
                    </tr>

                    <ng-container *ngIf="computeFaults(prompt) as faults">
                      <tr *ngIf="(faults | filled)">
                        <td colspan="7">
                          <fieldmagic-indent>
                            <span matTooltip="{{ 'Defects' | translate }}">{{ faults }}</span>
                          </fieldmagic-indent>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-template>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
  